<template>
  <PageContainer title="Nova auto escola" data-testid="cadastro-detran-page">
    <Box space="medium" class="form-container" data-testid="cadastro-detran-box">
      <div class="header-form" data-testid="cadastro-detran-header-form">
        <Input :mask="documentMask" legend="CNPJ/CPF" placeholder="00.000.000/0000-00 ou 000.000.000-00" :modelValue="searchCnpj"
          @update:modelValue="$event => searchCnpj = $event" class="input-full"
          data-testid="input-search-cnpj-agendamento" />

        <Button text="Consultar" color="primary" :disabled="loading" :fill="false" @handle:click="search" data-testid="button-consultar-cnpj">
          <Magnify :size="19" />
        </Button>
      </div>

      <div class="divider">
        <span>Informações da auto escola</span>
      </div>

      <form @submit.prevent="handleSubmit" data-testid="cadastro-detran-form">
        <div class="inputs" data-testid="cadastro-detran-inputs">
          <div class="inputs-row" data-testid="row-info-1">
            <Input legend="Nome fantasia" :modelValue="nomeFantasia" class="input-full"
              data-testid="input-nome-fantasia-agendamento" @update:modelValue="$event => nomeFantasia = $event" />

            <Input legend="Razão social" :modelValue="razaoSocial" class="input-full"
              data-testid="input-razao-social-agendamento" @update:modelValue="$event => razaoSocial = $event" />

            <Input :mask="documentMask" legend="CNPJ/CPF" placeholder="00.000.000/0000-00 ou 000.000.000-00" :modelValue="cnpj"
              @update:modelValue="$event => cnpj = $event" class="input-full input-cnpj"
              data-testid="input-cnpj-agendamento" />
          </div>

          <div class="inputs-row" data-testid="row-info-2">
            <Input type="email" legend="Email" :modelValue="email" class="input-full" data-testid="input-email"
              @update:modelValue="$event => email = $event" />

            <Input :mask="['(##) ####-####', '(##) #####-####']" legend="Telefone" :modelValue="telefone"
              class="input-full input-telefone" data-testid="input-telefone"
              @update:modelValue="$event => telefone = $event" />

            <Input mask="#####-###" legend="CEP" :modelValue="cep" class="input-full input-cep" data-testid="input-cep"
              @update:modelValue="$event => cep = $event" />
          </div>

          <!-- Só instrutor autônomo (CPF) pode ser vinculado; autoescola (CNPJ) não tem esse vínculo -->
          <template v-if="isCpf">
            <div class="divider">
              <span>Integração com o Detran</span>
            </div>

            <label class="opcao-vinculo" :class="{ ativa: vincularMonitoramento }" data-testid="opcao-vincular-monitoramento">
              <input type="checkbox" v-model="vincularMonitoramento" :disabled="loading" />
              <span class="checkbox"></span>

              <span class="texto">
                <strong>Vincular o instrutor à empresa de monitoramento</strong>
                <small>
                  Necessário para cadastrar veículos e emitir LADV. O Detran aceita um único vínculo ativo por
                  instrutor; se preferir, dá para vincular depois pela lista de autoescolas.
                </small>
              </span>
            </label>

            <!-- Fora do label: clicar no select não pode alternar o checkbox -->
            <div v-if="vincularMonitoramento" class="municipio-vinculo" data-testid="municipio-vinculo">
              <Select :options="optionsMunicipios" legend="Município principal de atuação"
                placeholder="Selecione o município" :modelValue="municipioPrincipal"
                @update:modelValue="$event => (municipioPrincipal = $event)" :disabled="loading"
                data-testid="select-municipio-principal" />

              <small>
                Define a regional do Detran: o instrutor só emite LADV para candidatos de municípios dessa regional.
                O município é gravado uma única vez; depois, só o Detran altera.
              </small>
            </div>
          </template>

          <div class="divider">
            <span>Localização</span>
          </div>

          <div class="inputs-row" data-testid="row-localizacao">
            <Input legend="Endereço" :modelValue="endereco" @update:modelValue="$event => endereco = $event"
              class="input-full" data-testid="input-endereco" />

            <Input legend="Número" :modelValue="numero" @update:modelValue="$event => numero = $event"
              class="input-full input-numero" data-testid="input-numero" />

            <Select class="input-full" :options="optionsConsultor" legend="Consultor" placeholder="Consultor"
              :modelValue="consultor" @update:modelValue="$event => (consultor = $event)" :disabled="loading" data-testid="select-consultor" />
          </div>

          <div class="divider">
            <span>Coordenadas principais</span>
          </div>

          <div class="inputs-row" data-testid="row-coordenadas-principais">
            <Input legend="Latitude" :modelValue="lat" @update:modelValue="$event => lat = $event" class="input-full"
              data-testid="input-lat" />

            <Input legend="Longitude" :modelValue="lon" @update:modelValue="$event => lon = $event" class="input-full"
              data-testid="input-lon" />
          </div>

          <div class="divider">
            <span>Coordenadas categoria A</span>
          </div>

          <div class="inputs-row" data-testid="row-coordenadas-categoria-a">
            <Input legend="Latitude" :modelValue="lat_categoria_a"
              @update:modelValue="$event => lat_categoria_a = $event" class="input-full" data-testid="input-lat" />

            <Input legend="Longitude" :modelValue="lng_categoria_a"
              @update:modelValue="$event => lng_categoria_a = $event" class="input-full" data-testid="input-lon" />
          </div>
        </div>

        <div class="buttons" data-testid="cadastro-detran-actions">
          <a :href="`https://www.google.com/maps/search/${lat},+${lon}/@${lat},${lon}?entry=ttu`" target="_blank"
            class="link-button primary" :class="{ disabled: !lat || !lon }" :tabindex="!lat || !lon ? -1 : 0"
            :aria-disabled="!lat || !lon" @click.prevent="(!lat || !lon) && $event.preventDefault()" data-testid="link-google-maps">
            <i class="fa fa-map mr-2"></i> Ver no Google Maps
          </a>

          <Button type="submit" text="Salvar" color="primary" :disabled="loading" data-testid="button-salvar-cfc">
            <ContentSaveOutline :size="19" />
          </Button>
        </div>
      </form>
    </Box>
  </PageContainer>
</template>

<script>
import utils from '../../services/utils'
import PageContainer from "core/PageContainer"
import Box from "core/Box"
import Input from "core/Input"
import Button from "core/Button"
import Select from "core/Select"
import { MUNICIPIOS_CE_OPTIONS, encontrarMunicipioCE } from '../../constants/municipiosCE'
import Magnify from 'icons/Magnify'
import ContentSaveOutline from 'icons/ContentSaveOutline'

export default {
  components: {
    PageContainer,
    Box,
    Input,
    Button,
    Select,

    Magnify,
    ContentSaveOutline,
  },
  data() {
    return {
      searchCnpj: '',
      razaoSocial: '',
      nomeFantasia: '',
      cnpj: '',
      email: '',
      telefone: '',
      cep: '',
      endereco: '',
      numero: '',
      vendedor: '',
      lat: '',
      lon: '',
      lat_categoria_a: '',
      lng_categoria_a: '',
      consultor: '',
      optionsConsultor: [],
      vincularMonitoramento: true,
      municipioPrincipal: '',
      optionsMunicipios: MUNICIPIOS_CE_OPTIONS,
      loading: false,
      url: `https://www.google.com/maps/search/${this.lat},+${this.lon}/@${this.lat},${this.log}`
    }
  },
  computed: {
    documentMask() {
      return ['###.###.###-##', '##.###.###/####-##']
    },
    isCpf() {
      return (this.cnpj || '').replace(/\D/g, '').length === 11
    },
  },
  watch: {
    cep(valor) {
      const cep = (valor || '').replace(/\D/g, '')
      // Só sugere: não sobrescreve um município já escolhido
      if (cep.length === 8 && this.isCpf && !this.municipioPrincipal) this.sugerirMunicipioPorCep(cep)
    },
  },
  created() {
    this.getVendedores();
  },
  methods: {
    formatDocument(value) {
      const digits = (value || '').replace(/\D/g, '')

      if (digits.length === 11) {
        return utils.formatarCPF(digits)
      }

      if (digits.length === 14) {
        return utils.formatarCNPJ(digits)
      }

      throw new Error('CPF ou CNPJ inválido')
    },
    async search() {
      this.loading = true

      if (!this.searchCnpj) {
        this.$toasted.show('CPF ou CNPJ inválido', {
          position: "top-right",
          duration: 5000,
          fullWidth: false
        });

        this.loading = false

        return
      }

      const cnpj = this.searchCnpj.replace(/[^\d]+/g, '')

      if (![11, 14].includes(cnpj.length)) {
        this.$toasted.show('CPF ou CNPJ inválido', {
          position: "top-right",
          duration: 5000,
          fullWidth: false
        });

        this.loading = false

        return
      }

      this.$http.get(`https://ws.novocfc.com.br/api/autoescolas/${cnpj}`)
        .then(res => {
          const dados = res.body.dados[0]

          this.cnpj = this.formatDocument(cnpj)
          this.nomeFantasia = dados.nomeFantasia
          this.razaoSocial = dados.razaoSocial
          this.endereco = `${dados.logradouro}, ${dados.bairro}, ${dados.cidade}`
          this.numero = dados.numero
          this.email = dados.email
          this.telefone = `859${dados.telefone1}`
          this.lat = dados.lat
          this.lon = dados.lon
          this.lat_categoria_a = dados.latCatA
          this.lng_categoria_a = dados.lonCatA
          this.municipioPrincipal = encontrarMunicipioCE(dados.cidade) || this.municipioPrincipal
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-info',
            position: 'top-right',
            duration: 3000,
            fullWidth: false
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    parseCoordenada(valor) {
      const texto = String(valor == null ? '' : valor).trim().replace(',', '.')
      return texto === '' ? NaN : Number(texto)
    },
    sugerirMunicipioPorCep(cep) {
      this.$http.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then(res => {
          if (res.body && res.body.uf === 'CE' && !this.municipioPrincipal) {
            this.municipioPrincipal = encontrarMunicipioCE(res.body.localidade)
          }
        })
        .catch(() => {})
    },
    async getVendedores() {
      await this.$http.get(`${process.env.VUE_APP_URL_API}/vendedores`)
        .then((res) => {
          const vendedores = res.body.dados.vendedores

          this.optionsConsultor = vendedores.map((vendedor) => ({
            value: vendedor.id,
            text: vendedor.nome
          }));
        });
    },
    async handleSubmit() {
      this.loading = true

      if (!this.nomeFantasia || !this.razaoSocial || !this.cnpj || !this.email || !this.telefone || !this.cep || !this.endereco || !this.numero || !this.consultor) {
        this.$toasted.show('Preencha todos os campos', {
          position: "top-right",
          duration: 5000,
          fullWidth: false
        });

        this.loading = false

        return
      }

      // Aceita vírgula decimal ("-3,7319"); vazio vira NaN e cai na mensagem
      const lat = this.parseCoordenada(this.lat)
      const lon = this.parseCoordenada(this.lon)

      if (!(Math.abs(lat) <= 90) || !(Math.abs(lon) <= 180)) {
        this.$toasted.show('Informe uma latitude e uma longitude válidas nas coordenadas principais', {
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })

        this.loading = false

        return
      }

      const latCategoriaA = this.parseCoordenada(this.lat_categoria_a)
      const lngCategoriaA = this.parseCoordenada(this.lng_categoria_a)

      if (!(Math.abs(latCategoriaA) <= 90) || !(Math.abs(lngCategoriaA) <= 180)) {
        this.$toasted.show('Informe uma latitude e uma longitude válidas nas coordenadas da categoria A', {
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })

        this.loading = false

        return
      }

      if (this.isCpf && this.vincularMonitoramento && !this.municipioPrincipal) {
        this.$toasted.show('Informe o município principal para vincular o instrutor ao monitoramento', {
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })

        this.loading = false

        return
      }

      let formattedDocument

      try {
        formattedDocument = this.formatDocument(this.cnpj)
      } catch (error) {
        this.$toasted.show(error.message, {
          position: "top-right",
          duration: 5000,
          fullWidth: false
        });

        this.loading = false

        return
      }

      const data = {
        nome_fantasia: this.nomeFantasia,
        razao_social: this.razaoSocial,
        cnpj: formattedDocument,
        email: this.email,
        telefone: ((t) => { const d = (t || '').replace(/\D/g, ''); return d.length >= 11 ? d.slice(0, 11).replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : d; })(this.telefone),
        cep: (this.cep || '').replace(/\D/g, '').slice(0, 8).replace(/(\d{5})(\d{1,3})/, '$1-$2'),
        endereco: this.endereco,
        numero: this.numero,
        lat,
        lon,
        lat_categoria_a: latCategoriaA,
        lng_categoria_a: lngCategoriaA,
      }

      if (this.isCpf) {
        data.vincular_monitoramento = this.vincularMonitoramento
        if (this.vincularMonitoramento) data.municipio_principal = this.municipioPrincipal
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API}/cfc`, data)
        .then(res => {
          this.$toasted.show(res.body.mensagem, {
            icon: 'fa-check',
            position: 'top-right',
            duration: 3000,
            fullWidth: false
          })

          // O cadastro não depende do vínculo: se o Detran recusar, avisa e dá para vincular depois pela lista
          const vinculo = res.body.vinculo_monitoramento
          if (vinculo) {
            this.$toasted.show(
              vinculo.sucesso ? vinculo.mensagem : `Autoescola criada, mas o vínculo com o monitoramento falhou: ${vinculo.mensagem}`,
              {
                icon: vinculo.sucesso ? 'fa-check' : 'fa-times',
                position: 'top-right',
                duration: vinculo.sucesso ? 3000 : 8000,
                fullWidth: false
              }
            )
          }
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-info',
            position: 'top-right',
            duration: 3000,
            fullWidth: false
          })

          if (err.body.errors) {
            Object.entries(err.body.errors).forEach(erro => {
              this.launchToast("fa-times", erro[1][0]);
            });
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    launchToast(icon, msg) {
      this.$toasted.show(msg, {
        icon: icon,
        position: "top-right",
        duration: 5000,
        fullWidth: false
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .header-form {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
  }

  .municipio-vinculo {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 28rem;

    small {
      font-size: 0.8125rem;
      line-height: 1.4;
      color: #6b7280;
    }
  }

  .opcao-vinculo {
    margin: 0;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;

    &.ativa {
      border-color: #1c2d5a;
      background-color: rgba(28, 45, 90, 0.04);
    }

    input[type='checkbox'] {
      display: none;
    }

    .checkbox {
      position: relative;
      flex-shrink: 0;
      width: 1.5rem;
      height: 1.5rem;
      border: 2px solid #dfdcdc;
      border-radius: 2px;
      background-color: #fafafa;
      transition: background-color 0.2s;
    }

    input[type='checkbox']:checked + .checkbox {
      border-color: #1c2d5a;
      background-color: #1c2d5a;

      &::after {
        content: '✓';
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 16px;
      }
    }

    .texto {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;

      strong {
        font-size: 0.875rem;
        color: #1c2d5a;
      }

      small {
        font-size: 0.8125rem;
        line-height: 1.4;
        color: #6b7280;
      }
    }
  }

  .divider {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    &::before,
    &::after {
      content: '';
      flex: 1 1 0;
      height: 1px;
      background-color: #e5e7eb;
    }

    span {
      white-space: nowrap;
      color: #6b7280;
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }

        .input-cnpj {
          max-width: 12rem;
        }

        .input-cep {
          max-width: 10rem;
        }

        .input-telefone {
          max-width: 10rem;
        }

        .input-numero {
          max-width: 10rem;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;

      .link-button {
        box-sizing: border-box;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.625rem;
        cursor: pointer;
        background: transparent;
        text-decoration: none;
        padding: 0.625rem;

        font-size: 0.875rem;
        font-weight: 700;
        line-height: 19.1px;

        &.primary {
          color: #1c2d5a;
          border: 1px solid #1c2d5a;
        }

        &.primary:hover:not(.disabled) {
          color: #142552;
          border: 1px solid #142552;
        }

        &.disabled {
          cursor: not-allowed;
          opacity: 0.7;
          pointer-events: none;
        }
      }
    }
  }
}
</style>
